import React from "react";
import { useState, useEffect } from 'react';
import axios, { AxiosResponse } from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Input, Col, Row, Label, Button, Spinner } from "reactstrap";
import qs from "qs";
import { UserObject } from "./MagniTypes";

class APICalls {


  private baseURL = process.env.REACT_APP_API_URL
  //private baseURL = "https://localhost:7214";
  //private baseURL = "https://api.themagnigroup.com"

  public LoginUser = async (formData: any): Promise<boolean> => {
    const response = await axios.post(
      this.baseURL + '/authorize',
      qs.stringify({
        grant_type: 'password',
        username: formData.userName,
        password: formData.password,
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    console.log(response);
    // Extract the access token and refresh token from the response
    const { access_token, refresh_token } = response.data;

    if (access_token === undefined || refresh_token === undefined) {
      return false;
    }
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('userName', formData.userName);

    return true;

  }




  public GetAllReports = async (loc?: string) => {
    const url = loc
      ? `${this.baseURL}/api/ConditionReports/GetAllReports?loc=${loc}`
      : `${this.baseURL}/api/ConditionReports/GetAllReports`;

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetAllCI = async () => {
    const url = `${this.baseURL}/api/ConditionReports/GetAllCI`

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetActiveCI = async () => {
    const url = `${this.baseURL}/api/ConditionReports/GetActiveCI`

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetClosedCI = async () => {
    const url = `${this.baseURL}/api/ConditionReports/GetClosedCI`

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetActiveReports = async (loc?: string) => {
    const url = loc
      ? `${this.baseURL}/api/ConditionReports/GetActiveReports?loc=${loc}`
      : `${this.baseURL}/api/ConditionReports/GetActiveReports`;

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetClosedReports = async (loc?: string) => {
    const url = loc
      ? `${this.baseURL}/api/ConditionReports/GetClosedReports?loc=${loc}`
      : `${this.baseURL}/api/ConditionReports/GetClosedReports`;

    const response = await axios.get(url);
    console.log(response);
    return response;
  }

  public GetReportByID = async (data: string) => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetReportByID?id=${data}`)
    return response;
  }

  public GetProducts = async () => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetCRProducts`)
    return response;
  }

  public GetCRUsers = async () => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetCRUsers`)
    return response;
  }

  public GetAssignedToUsers = async () => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetActAssignUsers`)
    return response;
  }

  public GetCustomers = async () => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetCustomers`)
    return response;
  }

  public AddReport = async (data: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddReport`, data
    )
    return response;
  }

  public EditReport = async (data: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/EditReport`, data
    )
    return response;
  }



  public AddItem = async (data: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddItem`, data
    )
    return response;
  }

  public EditItem = async (data: any) => {
    const response = await axios.put(
      `${this.baseURL}/api/ConditionReports/EditItem`, data
    )
    return response;
  }

  public DeleteItem = async (costID: number) => {
    const response = await axios.delete(
      `${this.baseURL}/api/ConditionReports/DeleteItem?costID=${costID}`
    )
    return response;
  }

  public GetItems = async (CRNumber: number) => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetItems?crNumber=${CRNumber}`
    )
    return response;
  }

  public AddRMA = async (data: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddRMA`, data
    )
    console.log(data)
    return response;
  }

  public EditRMA = async (data: any) => {
    const response = await axios.put(
      `${this.baseURL}/api/ConditionReports/EditRMA`, data
    )
    console.log(data)
    return response;
  }

  public DeleteRMA = async (RMAID: number) => {
    const response = await axios.delete(
      `${this.baseURL}/api/ConditionReports/DeleteRMA?id=${RMAID}`
    )
    console.log(RMAID)
    return response;
  }

  public GetRMA = async (CRNumber: number) => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetRMA?CRNum=${CRNumber}`
    )
    console.log(response.data)
    return response;
  }

  public AddProcess = async (data: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddProcess`, data
    )
    console.log(data)
    return response;
  }

  public EditProcess = async (data: any) => {
    const response = await axios.put(
      `${this.baseURL}/api/ConditionReports/EditProcess`, data
    )
    console.log(data)
    return response;
  }


  public GetCIByID = async (CINumber: number) => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetCIByID?CINum=${CINumber}`
    )
    console.log(response.data)
    return response;
  }

  public AddCI = async (contImprove: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddCI`, contImprove
    )
    console.log(contImprove)
    return response;
  }

  public EditCI = async (contImprove: any) => {
    const response = await axios.put(
      `${this.baseURL}/api/ConditionReports/EditCI`, contImprove
    )
    console.log(contImprove)
    return response;
  }

  public AddExpense = async (expense: any) => {
    const response = await axios.post(
      `${this.baseURL}/api/ConditionReports/AddExpense`, expense
    )
    console.log(expense)
    return response;
  }

  public EditExpense = async (expense: any) => {
    const response = await axios.put(
      `${this.baseURL}/api/ConditionReports/EditExpense`, expense
    )
    console.log(expense)
    return response;
  }

  public DeleteExpense = async (id: number) => {
    const response = await axios.delete(
      `${this.baseURL}/api/ConditionReports/DeleteExpense?id=${id}`
    )
    console.log(id)
    return response;
  }


  public GetCIByCR = async (crNumber: number) => {
    const response = await axios.get(
      `${this.baseURL}/api/ConditionReports/GetCIByCR?crNumber=${crNumber}`
    )
    console.log(response.data)
    return response;
  }

  public GetUserFromGraph = async (): Promise<any> => {
    try {
      // Check if we already have cached user data
      const cachedUser = localStorage.getItem('graphUser');
      if (cachedUser) {
        try {
          const userData = JSON.parse(cachedUser);
          if (userData && userData.displayName) {
            return userData;
          }
        } catch (e) {
          // Continue to fetch if cache is invalid
        }
      }

      // Get the Graph-specific token from localStorage
      const graphToken = localStorage.getItem('graphToken');

      if (!graphToken) {
        return {}; // Return empty object if no token
      }

      // Request expanded set of user fields to find what you need
      const response = await axios.get('https://graph.microsoft.com/v1.0/me?$select=displayName,officeLocation,department,jobTitle,companyName,businessPhones,city,country,mail,mobilePhone,postalCode,state,streetAddress,userPrincipalName', {
        headers: {
          'Authorization': `Bearer ${graphToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data) {
        // Store user data in localStorage
        localStorage.setItem('graphUser', JSON.stringify(response.data));
        console.log('Fetched data from Graph API:', response.data);

        // Store common fields separately for convenience
        if (response.data.officeLocation) {
          localStorage.setItem('userOfficeLocation', response.data.officeLocation);
          console.log('Office Location:', response.data.officeLocation);
        }

        if (response.data.department) {
          localStorage.setItem('userDepartment', response.data.department);
          console.log('Department:', response.data.department);
        }

        if (response.data.jobTitle) {
          localStorage.setItem('userJobTitle', response.data.jobTitle);
          console.log('Job Title:', response.data.jobTitle);
        }

        if (response.data.mail) {
          localStorage.setItem('userEmail', response.data.mail);
          console.log('Email:', response.data.mail);
        }

        // Add these lines to store city and state
        if (response.data.city) {
          localStorage.setItem('userCity', response.data.city);
          console.log('City:', response.data.city);
        }

        if (response.data.state) {
          localStorage.setItem('userState', response.data.state);
          console.log('State:', response.data.state);
        }

        return response.data;
      } else {
        console.warn('Graph API response missing data:', response.data);
        return {};
      }
    } catch (error) {
      console.error('Error fetching user data from Microsoft Graph:', error);
      return {}; // Return empty object on error
    }
  }

}


export default APICalls;